import { DicomColor } from '~/domain/dicom/dicomColor';
import { CurveData, Dvh } from '~/domain/patient/dvh';
import { buildDvhPoints } from '~/utils/dvhCurve';

export const PRIOR_CURVE_ALPHA = 0.45;

export interface ComparedDvh {
    readonly name: string;
    readonly color: DicomColor;
    readonly prior?: Dvh;
    readonly current?: Dvh;
}

const rgba = ({ R, G, B }: DicomColor, alpha: number) =>
    `rgba(${R}, ${G}, ${B}, ${alpha})`;

// Raw Gy on both sides: no display scale is applied to either dose.
export function dvhComparisonCurves(
    entries: readonly ComparedDvh[],
    grid: { readonly priorMaxGy: number; readonly currentMaxGy: number },
    labels: { readonly prior: string; readonly current: string }
): CurveData[] {
    const curves: CurveData[] = [];
    entries.forEach((entry, index) => {
        const sides = [
            {
                dvh: entry.current,
                maxGy: grid.currentMaxGy,
                label: labels.current,
                alpha: 1,
            },
            {
                dvh: entry.prior,
                maxGy: grid.priorMaxGy,
                label: labels.prior,
                alpha: PRIOR_CURVE_ALPHA,
            },
        ];
        for (const side of sides) {
            if (!side.dvh) {
                continue;
            }
            curves.push({
                data: buildDvhPoints(side.dvh, side.maxGy, 1),
                color: rgba(entry.color, side.alpha),
                name: `${entry.name} · ${side.label}`,
                visible: true,
                doseMaxGy: side.dvh.doseMaxGy,
                doseMinGy: side.dvh.doseMinGy,
                doseMeanGy: side.dvh.doseMeanGy,
                roiNumber: index,
                structureVolumeCm3: side.dvh.structureVolumeCm3,
            });
        }
    });
    return curves;
}
